import ApiService from '@/services/core/api.service'

const ProductService = {
  async get (query) {
    return ApiService.get(`admin/products?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/products', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/products/${payload.id}`, payload)
  }
}

export default ProductService
